import {ApiHelper} from 'cad/common/services/api/api-helper';
import {Observable} from 'rxjs';
import {OptionPda} from 'cad/flowing-gas/common/models/option-pda';
import {Injectable} from '@angular/core';
import ValidationResult = cad.ValidationResult;
import {
  VolumeExceptionRequest
} from 'cad/flowing-gas/pre-determined-allocation/models/volume-exception-request';
import {VolumeException} from 'cad/flowing-gas/pre-determined-allocation/models/volume-exception';
import {OptionPdaPeriod} from 'cad/flowing-gas/common/models/option-pda-period';

@Injectable()
export class OptionPdaApi {

  private readonly endpoint: string = 'allocation/predetermined-allocation';

  constructor(
        private apiHelper: ApiHelper) {
  }

  public find(params: Partial<OptionPda>): Observable<OptionPda[]> {
    return this.apiHelper.request(this.endpoint + '/filter', {body: params});
  }

  public save(params: OptionPda[]): Observable<ValidationResult<OptionPda[]>> {
    return this.apiHelper.request(`${this.endpoint}/submit`, { body: params });
  }

  public volumeException(params: Partial<VolumeExceptionRequest>): Observable<VolumeException> {
    return this.apiHelper.request(this.endpoint + '/measurement-details', {body: params});
  }

  public getAccountingDate(params:string): Observable<OptionPdaPeriod> {
    return this.apiHelper.request(`${this.endpoint}/accountingDate?flowDay=${params}`);
  }

  public getAllPdaPoints(): Observable<OptionPda[]> {
    return this.apiHelper.request(`${this.endpoint}/pda-points`);
  }
}
